export default __webpack_public_path__ + "static/media/mapaPR.a50ffb17.jpeg";